import {
  sendGetRequest
} from '@/helper/requests'

import choices from '@/urls/choices'

const state = {
  choices: {
    educationLevel: [],
    academicDegree: [],
    membersPosition: [],
  }
}

const getters = {
  getEducationLevel: state => state.choices.educationLevel,
  getAcademicDegree: state => state.choices.academicDegree,
  getMembersPosition: state => state.choices.membersPosition,
}

const actions = {
  loadEducationLevel: ({ commit }, { url, finalizer, catcher }) => {
    if (!url) url = choices.CHOICES.EDUCATION_LEVEL()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_EDUCATION_LEVEL', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadAcademicDegree: ({ commit }, { url, finalizer, catcher }) => {
    if (!url) url = choices.CHOICES.ACADEMIC_DEGREE()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_ACADEMIC_DEGREE', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadMembersPosition: ({ commit }, { url, finalizer, catcher }) => {
    if (!url) url = choices.CHOICES.MEMBERS_POSITION()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_MEMBERS_POSITION', data)
        finalizer(data, url)
      }, catcher
    )
  },
}

const mutations = {
  SET_EDUCATION_LEVEL: (state, value) => {
    state.choices.educationLevel = value
  },
  SET_ACADEMIC_DEGREE: (state, value) => {
    state.choices.academicDegree = value
  },
  SET_MEMBERS_POSITION: (state, value) => {
    state.choices.membersPosition = value
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
